<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>STATE<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="btn_state_save" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="states" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="stateColumns" [selectionField]="'State_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addState($event)" (editEntity)="editState($event)"
            (refreshEntities)="refreshStates($event)" (deleteEntity)="deleteState($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearState()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'State Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'StateName'" id="txt_state_Name" [(ngModel)]="entity.StateName"
                         ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" id="txt_state_Code" [formData]="entity" [maxlength]="10" [mandatory]="true"
                    [fieldName]="'Code'" [(ngModel)]="entity.Code"
                    ngDefaultControl></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'State Head'" id="drp_state_head"  [formData]="entity" [data]="employees" [mandatory]="false"
                    [filterable]="true" (filterChanged)="getAllEmployees($event)" [class] = "'form-control'"
                    [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                    [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee" ngDefaultControl>
                </dropdown>
                </div>
            </div>

            <div class="row"> 
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'"id="drp_state_Company" [formData]="entity" [data]="company" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllCompany($event)"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Zone'" [formData]="entity" [data]="zone" [class]="'form-control'"
                        [mandatory]="false" id="txt_state_Zone" [filterable]="true" (filterChanged)="getAllZone($event)"
                        [(ngModel)]="entity.Zone_Id" [textField]="'ZoneName'" [valueField]="'Zone_Id'"
                        [fieldName]="'Zone_Id'" [selectedItem]="selectedZone" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" id="txt_state_email" [formData]="entity" [maxlength]="100" [mandatory]="false"
                        [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl></textbox> 
                </div> 
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity" [mandatory]="false" [fieldName]="'Phone'"
                        [(ngModel)]="entity.Phone" id="txt_state_phone" (paste)="onPaste($event)" (keypress)="numberOnly($event)" [maxlength]="10" ngDefaultControl>
                    </textbox>
                </div> 
            </div>
            <div class="row">                 
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'"  [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div> 
            <div class="row">
                <!-- <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" id="btn_state_save" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div> -->
            </div>
        </div>
     
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="State Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="StateName" class="label label-1">State Name : </label> {{details.StateName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Code" class="label label-1">Code : </label> {{details.Code}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Emp_Ref_Id" class="label label-1">State Head : </label> {{details.EmployeeName}}
          </div>
         </div>
          <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="Zone_Id" class="label label-1">Zone : </label>  {{details.ZoneName}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Email" class="label label-1">Email Id : </label>  {{details.EmailId}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label>  {{details.Phone}}
          </div>
        </div>
        </div>
    </kendo-dialog>


<kendo-excelexport [data]="states.data" [collapsible]="true" fileName="State.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="StateName" title="State" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="StateCode" title="Code" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="EmployeeName" title="State Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column>  -->   
    <kendo-excelexport-column field="StateMail" title="Email" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="StatePhone" title="Phone" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ZoneName" title="Zone" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>